import React, { useState } from 'react'
import '../../components/kyc/kycStyle.css'
import ScreenHeader from '../../components/kyc/ScreenHeader'
import FormInput from '../../components/form/FormInput/FormInput'
import './TrustReport.css'
import Alert from '../../components/form/Alerts/BasicAlert'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import FormControlWithToolTip from '../../components/kyc/FormControlWithToolTip'

interface Props {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
  initialState: any
  setInitialState: React.Dispatch<React.SetStateAction<any>>
}

const TrustReport: React.FC<Props> = ({
  setShow,
  setIsError,
  setErrorMessage,
  initialState,
  setInitialState,
}) => {
  const [trustName, setTrustName] = useState<string>('')
  const [trustFileNumber, setTrustFileNumber] = useState<string>('')
  const [trustReference, setTrustReference] = useState<string>('')
  const price = 30

  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      trust: {
        trustName: trustName,
        trustFileNumber: trustFileNumber,
        trustReference: trustReference,
        price: price,
      },
    })
  }
  const handleSearch = () => {
    updateInitialState()
    // handle search logic
    //remember to setIsError and setErrorMessage to true or false when fetching api data
  }

  return (
    <div>
      <ScreenHeader
        headerText={'Trust'}
        subHeaderText={
          'Search on a Trust to confirm associated information and Trustees.'
        }
        price={price}
        sampleReport={'consumerreportVincent.pdf'}
      />
      <br />
      <Alert
        text={
          "The Golden rule of 'Less is More' applies. When performing a search providing the best chance at getting a successful search result, always enter the least amount of data to return a list of possible matches and choose the correct search subject. This is because our data suppliers may have captured a company or individual name differently to how you refer to them."
        }
        variant="primary"
        cssClass="primaryAlert"
      />
      <FormInput
        autoFocus
        required
        labelText="Trust name"
        placeHolderText="Enter trust name"
        onChangeHandler={setTrustName}
        value={trustName}
      />
      <FormControlWithToolTip
        required
        onChangeHandler={setTrustFileNumber}
        value={trustFileNumber}
        label={'Trust file number'}
        placeHolderText={'IT1234/1900'}
        toolTipText={
          'Trust name or Trust name and Trust File Number or Trust File Number'
        }
      />
      <FormInput
        labelText="Reference"
        placeHolderText="Search reference (optional)"
        onChangeHandler={setTrustReference}
        value={trustReference}
      />
      <FooterButtons
        handleSearch={handleSearch}
        setShow={setShow}
        isDisabled={!trustFileNumber && !trustFileNumber}
      />
    </div>
  )
}
export default TrustReport
